<template>
    <div :class="[commonClasses, 'row-label font-medium']">{{ headerText }}</div>
    <slot>
        <div :class="[commonClasses, 'file-cell']">
            <!-- File -->
            <label class="flex items-center font-inter font-normal">
                <input
                    v-if="!areValuesEqual"
                    :class="inputClasses"
                    :name="`${emdText}-${fileText}-radio`"
                    type="radio"
                    :value="nonNullFileValue"
                    @change="$emit('selected', nonNullFileValue!)"
                />
                {{ fileText }}
            </label>
        </div>
        <div :class="[commonClasses, 'emd-cell']">
            <!-- EMD -->
            <label class="flex items-center font-inter font-normal">
                <input
                    v-if="!areValuesEqual"
                    :class="inputClasses"
                    :name="`${emdText}-${fileText}-radio`"
                    type="radio"
                    :value="nonNullEmdValue"
                    @change="$emit('selected', nonNullEmdValue!)"
                />
                <span :class="{ 'font-italic text-content-secondary/70': areValuesEqual }">{{
                    areValuesEqual ? 'same as File' : emdText
                }}</span>
            </label>
        </div>
    </slot>
    <hr class="col-span-3" />
</template>

<script setup lang="ts">
import type { MergeRowProps } from '@/api/interfaces/early-deposit.types';
import { computed, onMounted } from 'vue';

const props = defineProps<MergeRowProps>();
const nonNullEmdValue = computed(() => props.emdValue ?? props.emdText);
const nonNullFileValue = computed(() => props.fileValue ?? props.fileText);
const areValuesEqual = computed(() => nonNullEmdValue.value === nonNullFileValue.value);

const emit = defineEmits<{
    selected: [formValue: string];
}>();

const commonClasses = 'py-6 cell';
const inputClasses = 'w-[1em] h-[1em] mr-2';

onMounted(() => {
    if (areValuesEqual.value) emit('selected', nonNullFileValue.value!);
});
</script>

<style lang="scss" scoped>
.cell {
    label,
    span {
        @apply font-inter;
    }
}
</style>
